import React from 'react';
import { plannedSegments } from './plannedSegments';
import { normalizeTime } from './rrhhUtils';

export default function PlannedSchedule({ turn, showDetails = false, fallback = 'Sin horario' }) {
  const segments = plannedSegments(turn);
  if (!segments.length) return fallback;

  return <span className="rrhh-planned-schedule">
    {segments.map((segment, index) => <span className="rrhh-planned-line" key={index}>
      <span className="rrhh-planned-range">{normalizeTime(segment.hora_inicio)} - {normalizeTime(segment.hora_fin)}</span>
      {showDetails && segment.actividad_ubicacion && <> · {segment.actividad_ubicacion}</>}
    </span>)}
  </span>;
}
